var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key,class:[`cascader-custom`]},[_c('el-cascader',{attrs:{"options":_vm.options,"props":_vm.props,"collapse-tags":"","clearable":""},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }